import { api } from '..';
import { McDeliveryPointEvent, McDeliveryPointReport } from './types';

export const mcDeliveryPointsApi = api.enhanceEndpoints({ addTagTypes: ['McDeliveryPoint'] }).injectEndpoints({
  endpoints: build => ({
    getMcDeliveryPointEvents: build.query<McDeliveryPointEvent[], { search?: string; isActive?: boolean }>({
      query: params => ({ url: 'v1/mc-delivery-points', params }),
      providesTags: ['McDeliveryPoint'],
    }),
    createMcDeliveryPointEvent: build.mutation<McDeliveryPointEvent, Partial<McDeliveryPointEvent>>({
      query: body => ({ url: 'v1/mc-delivery-points', method: 'POST', body }),
      invalidatesTags: ['McDeliveryPoint'],
    }),
    updateMcDeliveryPointEvent: build.mutation<
      McDeliveryPointEvent,
      { id: number; body: Partial<McDeliveryPointEvent> }
    >({
      query: ({ id, body }) => ({ url: `v1/mc-delivery-points/${id}`, method: 'PATCH', body }),
      invalidatesTags: ['McDeliveryPoint'],
    }),
    updateMcDeliveryPointStatus: build.mutation<McDeliveryPointEvent, { id: number; isActive: boolean }>({
      query: ({ id, isActive }) => ({
        url: `v1/mc-delivery-points/${id}/status`,
        method: 'PATCH',
        body: { isActive },
      }),
      invalidatesTags: ['McDeliveryPoint'],
    }),
    uploadMcDeliveryPointLogo: build.mutation<McDeliveryPointEvent, { id: number; logo: File }>({
      query: ({ id, logo }) => {
        const body = new FormData();
        body.append('logo', logo);
        return { url: `v1/mc-delivery-points/${id}/logo`, method: 'POST', body };
      },
      invalidatesTags: ['McDeliveryPoint'],
    }),
    downloadMcDeliveryPointQr: build.query<Blob, number>({
      query: id => ({
        url: `v1/mc-delivery-points/${id}/qr`,
        responseHandler: response => response.blob(),
      }),
    }),
    getMcDeliveryPointReport: build.query<McDeliveryPointReport, { id: number; startAt?: string; endAt?: string }>({
      query: ({ id, ...params }) => ({ url: `v1/mc-delivery-points/${id}/report`, params }),
    }),
  }),
});

export const {
  useGetMcDeliveryPointEventsQuery,
  useCreateMcDeliveryPointEventMutation,
  useUpdateMcDeliveryPointEventMutation,
  useUpdateMcDeliveryPointStatusMutation,
  useUploadMcDeliveryPointLogoMutation,
  useLazyDownloadMcDeliveryPointQrQuery,
  useLazyGetMcDeliveryPointReportQuery,
} = mcDeliveryPointsApi;
